var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-input',_vm._b({},'va-input',_vm.$props,false),[_c('v-rating',_vm._b({attrs:{"dense":"","color":_vm.color,"background-color":_vm.backgroundColor},on:{"change":_vm.change,"input":_vm.update}},'v-rating',_vm.commonProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }